import styled from 'styled-components';

export const WorkContainer = styled.div`
  background: #f3f1ea;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${'' /* padding: 0 30px; */}
  ${'' /* height: 900px; */}
  height: calc(100vh - 160px);
  position: relative;
  z-index: 1;

  ${'' /* height: fit-content; */}
  padding: 30px;

  @media screen and (max-width: 768px) {
    ${'' /* height: 1500px; */}
    padding: 20px;
    ${'' /* height: calc(100vh - 80px); */}
    height: fit-content;
  }

  ${
    '' /* 
  // возможно стоит убать этот before, тк он для того, чтобы сделать фон видео темнее
  :before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.2) 0%,
        rgba(0, 0, 0, 0.6) 100%
      ),
      linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, transperent 100%);

    z-index: 2;
  } */
  }
`;

export const WorkContent = styled.div`
  z-index: 3;
  max-width: 1200px;
  padding: 8px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const WorkH1 = styled.h3`
  color: #000;
  font-size: 26px;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 24px;
  }

  @media screen and (max-width: 480px) {
    font-size: 18px;
  }
`;

export const WorkP = styled.ul`
  margin-top: 24px;
  color: #000;
  font-size: 21px;

  ${'' /* @media screen and (max-width: 768px) {
    font-size: 19px;
  } */}

  @media screen and (max-width: 480px) {
    font-size: 16px;
  }
`;
export const WorkElem = styled.li`
  margin-top: 7px;
  ::marker {
    content: '— ';
  }
`;

export const WorkSubtext = styled.h3`
  font-size: 24px;
  margin-top: 25px;

  ${'' /* @media screen and (max-width: 760px) {
    font-size: 40px;
  } */}

  @media screen and (max-width: 480px) {
    font-size: 18px;
  }
`;

export const WorkSteps = styled.div`
  display: flex;
  @media screen and (max-width: 768px) {
    ${'' /* flex-direction: column; */}
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 15px 30px;
  }

  @media screen and (max-width: 400px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const WorkIconWrapper = styled.div`
  width: 100px;
  height: 100px;
  background-color: #dfbfb1;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
`;

export const WorkStepsIcon = styled.svg`
  width: 59px;
  height: 59px;
  margin-left: -20px;
`;
export const WorkStemsNumber = styled.div`
  content: ${({ stepNumber }) => (stepNumber ? stepNumber : '')};
  left: -17px;
  top: -30px;
  position: relative;
  background-color: #fff;
  color: #000;
  font-size: 13px;
  border-radius: 50%;
  height: 23px;
  width: 23px;
  display: block;
  text-align: center;
  line-height: 22px;
`;

export const WorkStepsTitle = styled.h5`
  color: #000;
  font-size: 16px;
  line-height: 19px;
  font-weight: 400;
  text-align: center;
`;

export const StepsItem = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 150px;
  margin: 0 20px;

  :nth-child(2n) {
    padding-top: 105px;
  }

  @media screen and (max-width: 1024px) {
    margin: 0;
  }

  @media screen and (max-width: 1024px) {
    :nth-child(2n) {
      padding-top: 0;
    }
  }

  ${
    '' /* @media screen and (max-width: 768px) {
        flex-direction: row;
    align-items: center;
    max-width: 100%;
        :nth-child(2n) {
            padding-top: 0;
    } */
  }
`;
